import { Container, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { string } from 'prop-types';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router';

import BottomNavigationBar from '../../components/Layouts/BottomNavigationBar/BottomNavigationBar';
import Footer from '../../components/Layouts/Footer/Footer';
import LayoutSingleColumn from '../../components/Layouts/LayoutSingleColumn';
import LayoutWrapperBottombar from '../../components/Layouts/LayoutWrapperBottombar/LayoutWrapperBottombar';
import LayoutWrapperFooter from '../../components/Layouts/LayoutWrapperFooter/LayoutWrapperFooter';
import LayoutWrapperMain from '../../components/Layouts/LayoutWrapperMain';
import LayoutWrapperTopbar from '../../components/Layouts/LayoutWrapperTopbar/LayoutWrapperTopbar';
import TopBar from '../../components/Layouts/TopBar/TopBar';
import Link from '../../components/Links/Link/Link';
import Page from '../../components/Page/Page';
import routeConfiguration from '../../routeConfiguration';
import { createResourceLocatorString } from '../../util/routes';

const formatTitle = (slug) => {
  let title = slug.split('-').join(' ');
  return title.charAt(0).toLocaleUpperCase() + title.slice('1');
};

const getSlug = (params) => {
  return `${params.slug}${params.rest ? `/${params.rest}` : ''}`;
};

const StoryblokErrorPage = ({ scrollingDisabled }) => {
  const intl = useIntl();
  const params = useParams();
  const slug = getSlug(params);

  const title = formatTitle(slug);

  return (
    <Page
      intl={intl}
      scrollingDisabled={scrollingDisabled}
      title={title}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopBar currentPage="StoryblokPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: {
                lg: 'calc(100vh - var(--topbarHeightDesktop))',
              },
            }}
          >
            <Container
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
              }}
            >
              <Typography variant="h1">
                <FormattedMessage id="StoryblokErrorPage.title" />
              </Typography>
              <Typography>
                <FormattedMessage id="StoryblokErrorPage.text" />
              </Typography>
              <Box>
                <Button
                  color="primary"
                  component={Link}
                  to={createResourceLocatorString(
                    'LandingPage',
                    routeConfiguration(),
                    {},
                    {},
                    intl.locale,
                  )}
                  variant="contained"
                >
                  <FormattedMessage id="StoryblokErrorPage.buttonText" />
                </Button>
              </Box>
            </Container>
          </Box>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
        <LayoutWrapperBottombar>
          <BottomNavigationBar />
        </LayoutWrapperBottombar>
      </LayoutSingleColumn>
    </Page>
  );
};

StoryblokErrorPage.prototype = {
  slug: string.isRequired,
};

export default StoryblokErrorPage;
